import React, { Component } from 'react';
import {Link} from "react-router-dom";
import UserController from "../controller/UserController";
import {Col, Dropdown, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faAddressBook,
    faCalendar, faCube, faCubes,
    faSheetPlastic, faSignOut, faTools, faUser, faUserAstronaut,
  faUserShield,
  faUserTie,
  faBuilding,
  faHome
} from "@fortawesome/free-solid-svg-icons";
import './UserMenu.css';
import logo from "../assets/bauabc_logo.PNG";
import APIController from "../controller/APIController";
import config from '../config';
import he from "he";


class UserMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetching:true
        }
    }


    getIconByType(type) {
        switch (type) {
            case "trainee":
            return faUser;

            case "supervisor":
            return faUserTie;

            case "instructor":
            return faBuilding;

            default:
            return faUser;
        }
    }

    _getStammgewerkNummerByProfessionId(professionId){
        if(professionId === undefined || professionId.toString().length !== 4){
            return null;
        }
        return professionId.toString()[1]+professionId.toString()[2];
    }
    async componentDidMount() {
        let allTopics = [];
        if(UserController.isInstructor()){
            allTopics = await APIController.getAllTopics();
            allTopics = allTopics.filter(t=>!t._id.endsWith("1"));
        }
        let myTrainees = [];
        let allMyProfessions = [];
        if(UserController.isSupervisor()){
            myTrainees = await APIController.getSingleSupervisorById(UserController.getUser().id);

            myTrainees.connectedTrainees.forEach(trainee => {
                if (!allMyProfessions.some(p => p.professionId === trainee.professionId)) {
                    allMyProfessions.push({
                        professionId: trainee.professionId,
                        professionName: trainee.professionName
                    })
                }
            });
        }


        this.setState({
            fetching:false,
            user: UserController.getUser(),
            myTrainees: myTrainees.connectedTrainees,
            myProfessions: allMyProfessions,
            currentPathName: this.props.currentPathName,
            allTopics :allTopics
        });
    }
    render() {
        let user = UserController.getUser();
        const groupedIdentities = UserController.getUser().identities.reduce((acc, id) => {
            if(id.id != user.id){
                const role = UserController.getUsertypeNameByUserType(id.type) || "Unbekannt"; // falls userRole fehlt
                if (!acc[role]) acc[role] = [];
                acc[role].push(id);
            }
            return acc;
        }, {});
        return (
            <div key={"userMenu_"+user.id}>
                <Row><Col xs={12} style={{background:'#006472',padding:'0.5em'}}>
                    <a style={{textDecoration:'none'}} href={UserController.getUsersHomeUrl()}>
                        <h5 style={{color:'white'}} className="text-uppercase"><img src={logo} style={{height: "30px",marginRight:'0.5em',marginLeft:'1em'}} className="App-logo" alt="logo"/> Digitales Arbeitsblatt</h5>
                    </a>
                </Col>
                </Row>
                <div className={"user-menu"}>
                    <Row>
                        <Col xs={10} sm={10} md={10} style={{display:'flex',justifyContent:'left',alignItems:'center'}}>
                            {(UserController.isSupervisor() || UserController.isTrainee()) &&
                                <Link
                                className={this.state.currentPathName === UserController.getMeinBauABCHomeUrl() ? 'active' : 'active-green'}
                                to={UserController.getMeinBauABCHomeUrl()}
                                >
                                <span title="Mein BAU ABC">
                                    <FontAwesomeIcon icon={faHome} /> <span className="nav-text">Mein BAU ABC</span>
                                </span>
                                </Link>
                            }

                            {UserController.isTrainee() &&
                                <><Link className={this.state.currentPathName === UserController.getUsersHomeUrl()? 'active':''} to={UserController.getUsersHomeUrl()}>
                                    <span><FontAwesomeIcon icon={faSheetPlastic} /> Projekte</span>
                                </Link>
                                <Link className={this.state.currentPathName === '/meine-kurse'? 'active':''} to={'/meine-kurse'}>
                                    <span><FontAwesomeIcon icon={faCalendar} /> Kurse</span>
                                </Link>
                                </>
                            }

                            {(!this.state.fetching && UserController.isSupervisor()) &&
                                <>
                                    <Dropdown  className={(this.state.currentPathName.startsWith('/trainee/'))?'active':''}>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faSheetPlastic}/> Arbeitsblätter</span>
                                            <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faSheetPlastic}/> Arbeitsblätter</span>
                                        </Dropdown.Toggle>
                                        <div>
                                            <Dropdown.Menu>
                                            {this.state.myTrainees.map((trainee,idx)=> {
                                                    let url = '/trainee/'+trainee._id+"/worksheets"
                                                    return(
                                                        <Dropdown.Item key={"dpi_topics"+url} onClickCapture={() =>  {window.location = url;}}>
                                                            <span><FontAwesomeIcon icon={faUser}/> {he.decode(trainee.firstname+" "+trainee.name)}</span>
                                                        </Dropdown.Item>
                                                    )
                                                })}

                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                    <Dropdown  className={(this.state.currentPathName.startsWith('/supervisor/topics'))?'active':''}>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faCubes}/> Projekte</span>
                                            <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faCubes}/> Projekte</span>
                                        </Dropdown.Toggle>
                                        <div>
                                            <Dropdown.Menu>
                                            {this.state.myProfessions.map((profession,idx)=> {
                                                    let url = '/supervisor/topics/'+profession.professionId
                                                    return(
                                                        <Dropdown.Item key={"dpi_topics"+url} onClickCapture={() =>  {window.location = url;}}>
                                                            <span><FontAwesomeIcon icon={faCube}/> {profession.professionName}</span>
                                                        </Dropdown.Item>
                                                    )
                                                })}
                                            {this.state.myTrainees.map((trainee,idx)=> {
                                                    let url = '/supervisor/topics/'+trainee.professionId+"/trainee/"+trainee._id
                                                    return(
                                                        <Dropdown.Item key={"dpi_topics"+url} onClickCapture={() =>  {window.location = url;}}>
                                                            <span><FontAwesomeIcon icon={faUser}/> {he.decode(trainee.firstname+" "+trainee.name)}</span>
                                                        </Dropdown.Item>
                                                    )
                                                })}
                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                </>
                            }

                            {(!this.state.fetching && UserController.isInstructor()) &&
                                <>
                                <Link className={(this.state.currentPathName.startsWith('/instructor'))?'active':''} to={UserController.getUsersHomeUrl()}>
                                    <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faCalendar}/> Kurse</span>
                                    <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faCalendar}/></span>
                                </Link>
                                    <Dropdown  className={(this.state.currentPathName.startsWith('/topics'))?'active':''}>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faSheetPlastic}/> Arbeitsblätter</span>
                                            <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faSheetPlastic}/> Arbeitsblätter</span>
                                        </Dropdown.Toggle>
                                        <div>
                                            <Dropdown.Menu style={{height:'15em',overflowY:'scroll'}}>
                                                <Dropdown.Item key={"dpi_topics"} onClickCapture={() =>  {window.location = '/topics'}}>
                                                    <span><FontAwesomeIcon icon={faSheetPlastic}/> Alle Arbeitsblätter</span>
                                                </Dropdown.Item>
                                                {this.state.allTopics.map((topicGroupedByProfession,idx)=> {

                                                    let stammdatengewerk = this._getStammgewerkNummerByProfessionId(topicGroupedByProfession._id);
                                                    let url = "";
                                                    if(stammdatengewerk != null){
                                                        url = '/topics/'+topicGroupedByProfession._id+"/*-"+stammdatengewerk+"-*"
                                                    }else{
                                                        url = '/topics/'+topicGroupedByProfession._id
                                                    }

                                                    return(
                                                        <Dropdown.Item key={"dpi_topics"+url} onClickCapture={() =>  {window.location = url;}}>
                                                            <span><FontAwesomeIcon icon={faTools}/>({topicGroupedByProfession._id}) {topicGroupedByProfession.professionName}</span>
                                                        </Dropdown.Item>
                                                    )
                                                })}
                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                </>
                            }

                            {((!this.state.fetching && UserController.isInstructorAdmin())) &&
                                <>
                                    <Dropdown  className={(this.state.currentPathName.startsWith('/templates'))?'active':''}>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faCubes}/> Templates</span>
                                            <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faCubes}/></span>
                                        </Dropdown.Toggle>
                                        <div>
                                            <Dropdown.Menu style={{height:'15em',overflowY:'scroll'}}>
                                                <Dropdown.Item key={"dpi_topics_templates"} onClickCapture={() =>  {window.location = '/templates'}}>
                                                    <span><FontAwesomeIcon icon={faCubes}/> Alle Templates</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item key={"dpi_topics_templates_all"} onClickCapture={() =>  {window.location = '/templates/-1'}}>
                                                    <span><FontAwesomeIcon icon={faCube}/> Gewerksübergreifend</span>
                                                </Dropdown.Item>
                                                {this.state.allTopics.map((topicGroupedByProfession,idx)=> {
                                                    return(
                                                        <Dropdown.Item key={"dpi_topics_t"+topicGroupedByProfession._id} onClickCapture={() =>  {window.location = '/templates/'+topicGroupedByProfession._id}}>
                                                            <span><FontAwesomeIcon icon={faTools}/>({topicGroupedByProfession._id}) {topicGroupedByProfession.professionName}</span>
                                                        </Dropdown.Item>
                                                    )
                                                })}
                                            </Dropdown.Menu>
                                        </div>
                                    </Dropdown>
                                </>
                            }
                            {this.state.fetching &&
                                <Link to={'/topics'}>
                                    <span className={"d-none d-sm-inline-block"}><FontAwesomeIcon icon={faSheetPlastic}/> Arbeitsblätter</span>
                                    <span className={"d-sm-inline-block d-sm-none"}><FontAwesomeIcon icon={faSheetPlastic}/></span>
                                </Link>
                            }

                        </Col>
                        <Col xs={2} sm={2} md={2} style={{display:'flex',justifyContent:'right',alignItems:'center'}}>
                            <Dropdown className={this.state.currentPathName === UserController.getMyProfileUrl()?'active':''}>
                                <Dropdown.Toggle variant="success" id="dropdown-basic">
                         <span className={'userType'}>
                            {UserController.isTrainee() &&
                                <FontAwesomeIcon icon={faUser} />
                            }
                             {UserController.isInstructor() &&
                                 <FontAwesomeIcon icon={faUserTie} />
                             }
                             {UserController.isAdmin() &&
                                 <FontAwesomeIcon icon={faUserAstronaut} />
                             }
                             <span className={"menuUserLoginName"} style={{marginLeft:'0.5em'}}>{UserController.getUser().email}</span>
                         </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClickCapture={() =>  {
                                        window.location = UserController.getMyProfileUrl();
                                    }}>
                                        <span>Mein Account</span>
                                    </Dropdown.Item>
                                    {UserController.isTrainee() &&
                                        <>
                                            <Dropdown.Item onClickCapture={() =>  {
                                                window.location = UserController.getMyProfileUrl() + "/update";
                                            }}>
                                                <span>Meine Profildaten</span>
                                            </Dropdown.Item>
                                        </>
                                    }

                                    <>
                                        <Dropdown.Item onClickCapture={() =>  {
                                            window.location = UserController.getKeycloakUpdatePasswordUrl();
                                        }}>
                                            <span>Passwort aktualisieren</span>
                                        </Dropdown.Item>
                                    </>

                                   
                                   
                                    <Dropdown.Divider />

                                    {Object.keys(groupedIdentities).length > 0 && 
                                        <Dropdown>
                                        <Dropdown.Toggle variant="success">Konto wechseln</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {Object.keys(groupedIdentities).map((role) => (
                                            <React.Fragment key={role}>
                                                <Dropdown.Header>{role.toUpperCase()}</Dropdown.Header>
                                                {groupedIdentities[role].map((id) => (
                                                <Dropdown.Item key={id.id} onClickCapture={() => UserController.switchLoginUser(id.id)}>
                                                    <FontAwesomeIcon icon={this.getIconByType(id.type)} /> {id.email}
                                                </Dropdown.Item>
                                                ))}
                                                <Dropdown.Divider />
                                            </React.Fragment>
                                            ))}
                                        </Dropdown.Menu>
                                        </Dropdown>
                                        }

                                    <Dropdown.Item onClickCapture={() => {
                                            let microsoftLogout = false;
                                            if(UserController.isInstructor() || UserController.isInstructorAdmin()){
                                                microsoftLogout = true;
                                            }
                                            APIController.logoutSessionUser();
                                            UserController.logout();

                                            if(microsoftLogout){
                                                window.location = 'https://login.microsoftonline.com/e48cfed5-edc8-4ab5-a9f7-9cb31f72a6b0/oauth2/v2.0/logout'
                                            }else{
                                                window.location.href = "/";
                                            }
                                    }}>
                                        <span><FontAwesomeIcon icon={faSignOut}/> Ausloggen</span>
                                    </Dropdown.Item>

                                </Dropdown.Menu>
                            </Dropdown>
                        </Col>
                    </Row>
                </div>
            </div>

        )
    }
}


export default UserMenu;